const BACKGROUNDS_BY_SEASON = {
  autumn: {
    default: {
      url: 'https://images.unsplash.com/photo-1603373659283-f0728b2621c2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtdXNrb2thJTIwb250YXJpbyUyMGNvdHRhZ2UlMjBsYWtlJTIwZG9ja3xlbnwxfHx8fDE3ODI2NTcwOTB8MA&ixlib=rb-4.1.0&q=80&w=1080',
      label: 'Muskoka lake at sunset',
    },
  },
};

export function getGuestDayBackground({ season = 'autumn', dayId = 'default' } = {}) {
  const seasonal = BACKGROUNDS_BY_SEASON[season] || BACKGROUNDS_BY_SEASON.autumn;
  return seasonal[dayId] || seasonal.default || BACKGROUNDS_BY_SEASON.autumn.default;
}

export { BACKGROUNDS_BY_SEASON };
